<template>
  <div class="side-nav-wrap">
    <div class="side-nav-brand" :class="{ 'is-collapse': collapse }" @click="goHome" title="返回首页">
      <img class="side-nav-logo" :src="logoUrl" alt="PhotoEasy" />
      <span class="side-nav-title" v-show="!collapse">PhotoEasy</span>
    </div>
    <el-menu
      router
      unique-opened
      :default-active="activeIndex"
      :collapse="collapse"
      class="el-menu side-nav-menu"
      background-color="#2f3e4e"
      text-color="#fff"
      active-text-color="#409EFF">
      <el-submenu index="1" v-if="$hasPermission('A1')">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>业务办理</span>
        </template>
        <el-menu-item v-if="$hasPermission('A101')" index="/business/photoInfo">拍照信息管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A102')" index="/business/paysInfo">缴费信息管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A103')" index="/business/refund">退款记录</el-menu-item>
      </el-submenu>
      <el-submenu index="2" v-if="$hasPermission('A2')">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span>统计报表</span>
        </template>
        <el-menu-item v-if="$hasPermission('A201')" index="/form/day">每日统计</el-menu-item>
        <el-menu-item v-if="$hasPermission('A202')" index="/form/month">每月统计</el-menu-item>
        <el-menu-item v-if="$hasPermission('A203')" index="/form/device">设备统计</el-menu-item>
      </el-submenu>
      <el-submenu index="3" v-if="$hasPermission('A3')">
        <template slot="title">
          <i class="el-icon-s-tools"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item v-if="$hasPermission('A301')" index="/system/channel">渠道管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A302')" index="/system/device">设备管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A303')" index="/system/payconfig">支付配置</el-menu-item>
        <el-menu-item v-if="$hasPermission('A304')" index="/system/users">帐户管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A305')" index="/system/role">权限管理</el-menu-item>
        <el-menu-item v-if="$hasPermission('A306')" index="/system/photoType">相片规格</el-menu-item>
      </el-submenu>
      <el-submenu index="4" v-if="$hasPermission('A4')">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>安全审计</span>
        </template>
        <el-menu-item v-if="$hasPermission('A401')" index="/safe/operationLog">操作日志</el-menu-item>
        <el-menu-item v-if="$hasPermission('A402')" index="/safe/securityLog">安全日志</el-menu-item>
        <el-menu-item v-if="$hasPermission('A403')" index="/safe/loginLog">登录日志</el-menu-item>
        <el-menu-item v-if="$hasPermission('A404')" index="/safe/ipLock">锁定IP</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import logoUrl from '../../assets/logo.png'

export default {
  name: 'SideMenu',
  props: {
    collapse: { type: Boolean, default: false }
  },
  data() {
    return { activeIndex: '', logoUrl }
  },
  created() {
    this.activeIndex = this.$route.path === '/home' ? '' : this.$route.path
  },
  watch: {
    '$route.path'(path) {
      this.activeIndex = path === '/home' ? '' : path
    }
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/home' })
      this.activeIndex = ''
    }
  }
}
</script>

<style>
.side-nav-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.side-nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 16px;
  box-sizing: border-box;
  cursor: pointer;
  background-color: #2f3e4e;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
  user-select: none;
}

.side-nav-brand:hover { background-color: #364859; }
.side-nav-brand.is-collapse { justify-content: center; padding: 0 8px; }

.side-nav-logo {
  height: 32px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.side-nav-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
}

.el-menu-item { margin-left: 15px; }

.side-nav-menu {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.side-nav-menu:not(.el-menu--collapse) { width: 200px; }
</style>
